module.exports = __webpack_public_path__ + "img/Bear33.e93dd23b.jpg";